export default [
  {
    path: '/services',
    name: 'Services',
    component: () => import('@/views/Services/Index.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Servis',
        },
        {
          text: 'Giriş Adetleri',
          active: true,
        },
      ],
      resource: 'RP_SERVICES',
      action: 'read',
    },
  },
  {
    path: '/services/payment',
    name: 'ServicePayment',
    component: () => import('@/views/Services/Payment.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Servis',
        },
        {
          text: 'Ciro',
          active: true,
        },
      ],
      resource: 'RP_SERVICES',
      action: 'read',
    },
  },
  {
    path: '/services/car-payment',
    name: 'CarPayment',
    component: () => import('@/views/Services/CarPayment.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Servis',
        },
        {
          text: 'Araç Başı Ciro',
          active: true,
        },
      ],
      resource: 'RP_SERVICES',
      action: 'read',
    },
  },
  {
    path: '/services/accessory-sale',
    name: 'AccessorySale',
    component: () => import('@/views/Services/AccessorySales.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Servis',
        },
        {
          text: 'Aksesuar Satışı',
          active: true,
        },
      ],
      resource: 'RP_SERVICES',
      action: 'read',
    },
  },
  {
    path: '/services/gross-profit',
    name: 'GrossProfit',
    component: () => import('@/views/Services/GrossProfit.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Servis',
        },
        {
          text: 'Brüt Kar',
          active: true,
        },
      ],
      resource: 'RP_SERVICES',
      action: 'read',
    },
  },

]
